import React from 'react';
import { MegaMenuSectionTitle } from './MegaMenuSectionTitle';
import { MegaMenuLink } from './MegaMenuLink';
import { MegaMenuCTA } from './MegaMenuCTA';
import ConsignmentCTAImage from 'images/megamenu/consignment-cta-image.jpg';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuConsignmentPage = () => {
  const { sendHotjarEvent } = React.useContext(AnalyticsContext);
  const { megaMenuState } = useMegaMenu();
  return (
    <div>
      <div className='grid grid-cols-2 xl:grid-cols-3 gap-x-10'>
        <div className='xl:col-span-2 grid grid-cols-1 xl:grid-cols-2 gap-x-10 gap-y-6 py-5'>
          <div className='flex flex-col gap-3'>
            <MegaMenuSectionTitle title='Consignment' to='/consignment'/>
            <div className='flex flex-col gap-4'>
              <MegaMenuLink
                label='Consignment Process' to='/consignment/consignment-process'
                onPress={() => megaMenuState.close()}
                description={
                  'From evaluation to auction day, the process couldn\'t be easier.'
                  + ' Here is the step-by-step plan to get you started.'
                }
              />
              <MegaMenuLink
                label='Where Legends Come to Sell' to='/consignment/notable-collectors'
                description={'Learn more about most renowned names in collecting'
                  + ' and why they have chosen Rock Island Auction Company.'}
                onPress={() => megaMenuState.close()}
              />
            </div>
          </div>
          <div className='flex flex-col gap-3'>
            <div className='flex flex-col gap-4 -mt-1 xl:mt-0 xl:pt-10'>
              <MegaMenuLink
                label='Market Defining Results' to='/consignment/past-auction-successes'
                description={'Examine the company\'s top 100 items across every segment of the firearms field.'}
                onPress={() => megaMenuState.close()}
              />
            </div>
          </div>
        </div>
        <div className='w-full'>
          <MegaMenuCTA
            to='/consignment/getting-started'
            onPress={() => {
              megaMenuState.close();
              sendHotjarEvent('UX-mega_menu_consignment_cta_clicked');
            }}
            buttonLabel='Start Selling'
            src={ConsignmentCTAImage}
            id='mega-menu-consignment-cta'/>
        </div>
      </div>
    </div>
  );
};
